import { getFetchedDataPayload } from '@vista-digital/utilities';
import { salesDataDomainStore } from '../../store';
export const getSubscriptionBillingOptionById = (id) => {
    var _a;
    return (_a = getFetchedDataPayload(salesDataDomainStore.data.subscriptionBillingOptionsById)) === null || _a === void 0 ? void 0 : _a[id];
};
//# sourceMappingURL=get-subscription-billing-option-by-id.js.map